import React from 'react';
import PrimaryBtn from 'src/Components/GlobalComponents/primaryBtn';
import SimpleInput from 'src/Components/SimpleInput';
import { IPharmaInventoryCreate } from 'src/types/GlobalInterfaces';

interface IProps {
    state: IPharmaInventoryCreate;
    setState: (key: keyof IPharmaInventoryCreate, val: string) => void;
    tabChange: () => void;
};

const InventoryPriceTab: React.FC<IProps> = ({ state, setState, tabChange }) => {
    return (
        <>
            <div className='products-tabs-content'>
                <SimpleInput
                    min={1}
                    type="number"
                    value={state?.regularPrice}
                    onChange={(val) => setState("regularPrice", val)}
                    isLabel={true}
                    maxLength={12}
                    labelText="Regular Price"
                    onKeyDown={(e: any) => {
                        if (["e", "E", "-", "+"].includes(e.key)) {
                            e.preventDefault();
                        }
                    }}
                    id="regular-price-input"
                />
                <SimpleInput
                    min={1}
                    type="number"
                    value={state?.salePrice || ""}
                    onChange={(val) => setState("salePrice", val)}
                    isLabel={true}
                    maxLength={12}
                    labelText="Sale Price"
                    onKeyDown={(e: any) => {
                        if (["e", "E", "-", "+"].includes(e.key)) {
                            e.preventDefault();
                        }
                    }}
                    id="sale-price-input"
                />
            </div>
            <div className='flex justify-end my-6'>
                <PrimaryBtn
                    ButtonText="Next"
                    btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
                    onPress={tabChange}
                    id="next-btn"
                />
            </div>
        </>
    );
};

export default InventoryPriceTab;